import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import CompleteReport from './App.vue'

import initBugsnag from '@/helpers/initBugsnag'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(CompleteReport)
const bugsnagVue = initBugsnag('Lifestyle Web - Complete Report')

app.use(pinia)
app.use(bugsnagVue)
app.mount('#complete-report-container')